
var Marketing = new function(){
	this.download = function(e){
		var parent = e.parentNode.parentNode;
        var atag = parent.querySelector("a");
        var src = e.attributes["data-src"].value;
        var type = e.attributes["data-type"].value;
        atag.href = src;
        atag.className = type;
        e.querySelector("input").checked = true;
 	}
}